import { isPlatformServer } from '@angular/common';
import { HttpInterceptorFn } from '@angular/common/http';
import { inject, PLATFORM_ID } from '@angular/core';
import { timeout } from 'rxjs';

export const HTTP_TIMEOUT_MS = 30_000;
export const SSR_HTTP_TIMEOUT_MS = 3_000;

export const timeoutInterceptor: HttpInterceptorFn = (request, next) => {
  const timeoutMs = isPlatformServer(inject(PLATFORM_ID)) ? SSR_HTTP_TIMEOUT_MS : HTTP_TIMEOUT_MS;

  return next(request).pipe(timeout(timeoutMs));
};
